export default "__VITE_PUBLIC_ASSET__d821d5f8__"